var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-ar-distance"},[_vm._v(" "+_vm._s(Math.round(_vm.stepsCount*0.6))+" / "+_vm._s(_vm.distance)+" m ")])}
var staticRenderFns = []

export { render, staticRenderFns }